export const formatCurrency = (value) => {
  if (value === undefined || value === null) return 'Rp. 0';
  return `Rp. ${new Intl.NumberFormat('id').format(value)}`;
};

export const formatCompactNumber = (value) => {
  if (value === undefined || value === null) return '0';
  return new Intl.NumberFormat('id', {
    notation: 'compact',
    compactDisplay: 'long',
  }).format(value);
};
